<nav class="navbar navbar-expand-lg py-0">
  <button
    (click)="isCollapsed=!isCollapsed"
    class="navbar-toggler py-2 mx-2 my-2"
    type="button"
    data-toggle="collapse"
    data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent"
    aria-expanded="false"
    aria-label="Toggle navigation"
  >
    <i class="bi bi-list"></i>
  </button>

  <div [ngbCollapse]="isCollapsed" class="collapse navbar-collapse thead-dark ml-3" id="navbarSupportedContent">
    <div class="navbar-nav">
      <div class="nav-item px-2 mx-1" routerLinkActive="active rounded" style="width: 9rem">
        <a class="nav-link p-0" [routerLink]="['/home']">
          <img style="width: 100%" [src]="'assets/background/alpha-sound-bg2.png'" alt=""
        /></a>
      </div>
      <div class="nav-item px-2 pt-1 mx-1" routerLinkActive="active rounded">
        <a class="nav-link" [routerLink]="['/song']"
          ><h3><i class="bi bi-music-note"></i> {{ 'common.entity.song' | translate }}</h3></a
        >
      </div>
      <div class="nav-item px-2 pt-1 mx-1" routerLinkActive="active rounded">
        <a class="nav-link" [routerLink]="['/album']"
          ><h3><i class="bi bi-disc"></i> {{ 'common.entity.album' | translate }}</h3></a
        >
      </div>
      <div class="nav-item px-2 pt-1 mx-1" routerLinkActive="active rounded">
        <a class="nav-link" [routerLink]="['/artist']"
          ><h3><i class="bi bi-mic"></i> {{ 'common.entity.artist' | translate }}</h3></a
        >
      </div>
    </div>

    <div
      class="slider-container d-inline-flex justify-content-center align-items-center text-white rounded-pill"
      style="background-color: #6c757d !important; min-height: 2rem; min-width: 8rem"
    >
      <i class="bi bi-sun"></i>
      <input
        type="range"
        min="1"
        [max]="2"
        [value]="(setting$ | async).darkMode ? 2 : 1"
        class="custom-range bg-secondary"
        id="myRange"
        (change)="turnDarkThemeOnOff($event)"
      />
      <i class="bi bi-moon-stars"></i>
    </div>
    <div ngbDropdown class="d-inline-block mx-auto" *ngIf="!!currentUser">
      <button
        ngbDropdownToggle
        class="dropdown-toggle btn btn-info mx-0 rounded-pill"
        id="uploadSelect"
        role="button"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <i class="bi bi-upload"></i>
      </button>
      <div ngbDropdownMenu class="dropdown-menu" aria-labelledby="uploadSelect">
        <a ngbDropdownItem class="dropdown-item" [routerLink]="['/song','upload']">{{ 'feature.song.upload_song' | translate }}</a>
        <div class="dropdown-divider"></div>
        <a ngbDropdownItem class="dropdown-item" [routerLink]="['/album','upload']">{{ 'feature.album.upload_album' | translate }}</a>
      </div>
    </div>

    <div class="row row-cols-lg-auto mx-auto">
      <input
        class="form-control rounded-pill mr-1"
        type="search"
        aria-label="Search"
        style="width: 12rem"
        [(ngModel)]="searchText"
        [placeholder]="'common.button.search' | translate"
        (keyup.enter)="onSearch()"
      />
      <button (click)="onSearch()" type="button" class="btn btn-info mx-1 rounded-circle"><i class="bi bi-search"></i></button>
    </div>
  </div>
  <div ngbDropdown class="d-inline-block ml-auto mr-1" *ngIf="!currentUser" placement="bottom-end" display="dynamic">
    <button class="btn btn-info rounded-pill" id="dropdownForm1" ngbDropdownToggle>
      <i class="bi bi-box-arrow-in-right"></i> {{ 'feature.account.login' | translate}}
    </button>
    <div ngbDropdownMenu aria-labelledby="dropdownForm1">
      <form [formGroup]="loginForm" (ngSubmit)="onSignIn()" class="px-4 py-3" vgFocusFirstInvalid [form]="loginForm">
        <div class="form-group">
          <label for="username" class="text-light my-1">{{ 'feature.account.username' | translate }}</label>
          <input
            formControlName="username"
            type="text"
            class="form-control"
            id="username"
            [placeholder]="'common.placeholder.username' | translate"
          />
          <vg-error-section [label]="'feature.account.username' | translate" [group]="loginForm" controlName="username"></vg-error-section>
        </div>
        <div class="form-group">
          <label for="exampleDropdownFormPassword1" class="text-light my-1">{{ 'feature.account.password' | translate }}</label>
          <input
            formControlName="password"
            type="password"
            autocomplete
            class="form-control"
            id="exampleDropdownFormPassword1"
            [placeholder]="'common.placeholder.password' | translate"
          />
          <vg-error-section [label]="'common.label.password' | translate" [group]="loginForm" controlName="password"></vg-error-section>
        </div>
        <div class="form-check my-1">
          <input type="checkbox" class="form-check-input" id="dropdownCheck" formControlName="rememberMe" />
          <label class="form-check-label text-light" for="dropdownCheck">{{ 'feature.account.remember_me' | translate}}</label>
        </div>
        <button type="submit" class="btn btn-info my-1" [disabled]="loginForm.invalid">
          <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
          <span class="text-dark">{{ 'feature.account.login' | translate }}</span>
        </button>
      </form>
      <hr />
      <!--      <div class="dropdown-divider"></div>-->
      <a ngbDropdownItem class="dropdown-item text-center" [routerLink]="['/register']">{{ 'feature.account.sign_up_hint' | translate}}</a>
      <a ngbDropdownItem class="dropdown-item text-center" [routerLink]="['/reset-password']"
        >{{ 'feature.account.forgot_password' | translate }}</a
      >
    </div>
  </div>
  <div ngbDropdown class="d-inline-block ml-auto mr-1" *ngIf="!!currentUser" placement="bottom" display="dynamic">
    <button
      ngbDropdownToggle
      class="dropdown-toggle btn btn-warning rounded-pill"
      id="userProfile"
      role="button"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <span class="d-inline-block user-avatar" *ngIf="!currentUser?.avatar_url"> <i class="bi bi-person-circle"></i></span>
      <img class="d-inline-block user-avatar" *ngIf="!!currentUser?.avatar_url" [src]="currentUser?.avatar_url | mediaUrl:true" alt="" />
      <span class="text-dark"> {{ currentUser.user_name }}</span>
    </button>
    <div ngbDropdownMenu class="dropdown-menu" aria-labelledby="userProfile">
      <a ngbDropdownItem class="dropdown-item" [routerLink]="['/profile']"
        ><i class="bi bi-person-circle"></i> {{ 'feature.account.profile' | translate }}</a
      >
      <a ngbDropdownItem class="dropdown-item" [routerLink]="['/playlist']"
        ><i class="bi bi-music-note-list"></i> {{ 'common.entity.playlist' | translate }}</a
      >
      <ng-container *ngIf="isAdmin">
        <div class="dropdown-divider"></div>
        <a ngbDropdownItem class="dropdown-item" [routerLink]="['/admin/dashboard']"
          ><i class="bi bi-person-square"></i> {{ 'common.label.admin_page' | translate }}</a
        >
      </ng-container>
      <div class="dropdown-divider"></div>
      <a ngbDropdownItem class="dropdown-item" [routerLink]="['/uploaded/song']"
        ><i class="bi bi-upload"></i> {{ 'feature.song.uploaded_song' | translate }}</a
      >
      <a ngbDropdownItem class="dropdown-item" [routerLink]="['/uploaded/album']"
        ><i class="bi bi-upload"></i> {{ 'feature.album.uploaded_album' | translate }}</a
      >
      <a ngbDropdownItem class="dropdown-item" [routerLink]="['/favorites']"
        ><i class="bi bi-bookmark-heart"></i> {{ 'feature.favorites.item' | translate }}</a
      >
      <a ngbDropdownItem (click)="confirmLogout()" class="dropdown-item" tabindex="-1" aria-disabled="true"
        ><i class="bi bi-box-arrow-right"></i> {{ 'feature.account.logout' | translate }}</a
      >
    </div>
  </div>
  <div class="d-inline-block ml-auto mx-2">
    <div id="language" class="btn-group mr-3" style="width: 6rem">
      <div #langList="ngbDropdown" class="btn-group w-100" ngbDropdown role="group" placement="bottom" display="dynamic">
        <button class="btn btn-secondary dropdown-toggle-split d-flex align-items-center justify-content-between" ngbDropdownToggle>
          <i class="bi bi-globe2"></i>
          <i class="bi bi-caret-down-fill" *ngIf="langList._open; else closeLang"></i>
          <ng-template #closeLang>
            <i class="bi bi-caret-right-fill"></i>
          </ng-template>
          <img
            class="ml-2 flag-image"
            [src]="'assets/flags/'+ translate.currentLang + '-flag.png'"
            [alt]=" translate.currentLang + '_flag'"
          />
        </button>

        <div class="dropdown-menu" ngbDropdownMenu>
          <button ngbDropdownItem (click)="changeLang('vi')">
            <img class="flag-image" [src]="'assets/flags/vi-flag.png'" alt="vi_flag" />&nbsp; {{'common.lang.vi' | translate}}
          </button>
          <button ngbDropdownItem (click)="changeLang('en')">
            <img class="flag-image" [src]="'assets/flags/en-flag.png'" alt="en_flag" />&nbsp; {{'common.lang.en' | translate}}
          </button>
        </div>
      </div>
    </div>
  </div>
</nav>
